/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as DropdownIcon } from "icons/dropdown_arrow_purple.svg";

const RecentActivity = ({ activity }) => {
  const [ascending, setAscending] = useState(true);

  const handleSort = () => {
    setAscending(!ascending);
    activity.reverse();
  };
  const handleViewMore = () => {
    window.Ext.getCmp("sideBar").selectNodeById("sidebar-nav-reports");
    setTimeout(() => {
      window.Ext.getCmp("ReportsPanel").setActiveTab(2);
    }, 150);
  };

  return (
    <div className="recent_activity" data-testid="recent-activity">
      <span className="recent_activity__title">Recent Activity</span>
      {activity.length === 0 ? (
        <div className="recent_activity__no_data">
          <span>No data</span>
        </div>
      ) : (
        <div className="recent_activity__table">
          <div className="recent_activity__table__row header">
            <div
              onClick={handleSort}
              className={`recent_activity__table__row__datetime ${
                ascending ? "ascending" : "descending"
              }`}
            >
              Date/Time
              <DropdownIcon />
            </div>
            <div className="recent_activity__table__row__description ">
              Description
            </div>
            <div className="recent_activity__table__row__folder">Folder</div>
            <div className="recent_activity__table__row__user">User</div>
          </div>
          <div className="recent_activity__table__row__content">
            {activity.map((item, index) => {
              let descriptionLink;
              let folderLink;
              if (item.docId !== undefined) {
                descriptionLink = () => {
                  window.Application.common.drillInto(
                    0,
                    item.docSetId,
                    item.docId
                  );
                };
              }
              if (item.docSetId !== undefined) {
                folderLink = () => {
                  window.Application.common.drillInto(0, item.docSetId);
                };
              }
              return (
                <div
                  key={`recent_activity_row_${index}`}
                  className={`recent_activity__table__row ${
                    index === 0 ? "first" : ""
                  }`}
                >
                  <div className="recent_activity__table__row__datetime">
                    {item.timeAsFormattedString}
                  </div>
                  <div
                    className={`recent_activity__table__row__description ${
                      descriptionLink !== undefined ? "link" : ""
                    }`}
                    onClick={descriptionLink}
                  >
                    {item.activityDescription}
                  </div>
                  <div
                    className={`recent_activity__table__row__folder ${
                      folderLink !== undefined ? "link" : ""
                    }`}
                    onClick={folderLink}
                  >
                    {item.docSetName}
                  </div>
                  <div className="recent_activity__table__row__user">
                    {item.userName}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="recent_activity__table__row last">
            <div className="recent_activity__table__row__datetime" />
            <div className="recent_activity__table__row__description" />
            <div className="recent_activity__table__row__folder" />
            <div className="recent_activity__table__row__user">
              <span onClick={handleViewMore}>View More</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentActivity;

RecentActivity.propTypes = {
  activity: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
